import { ComposedModal, ModalHeader, Tab, Tabs } from "carbon-components-react";
import { useParams } from "react-router-dom";
import CheckDomainAvailabilityForm from "forms/CheckDomainAvailabilityForm/CheckDomainAvailabilityForm";
import { useContext, useEffect, useState } from "react";
import MainContext from "context/MainContext";
import RegisterDomainForm from "forms/RegisterDomainForm/RegisterDomainForm";
import CreateDomainAssociationForm from "forms/CreateDomainAssociationForm/CreateDomainAssociationForm";
import useUser from "hooks/useUser";
import { getAwsApps } from "api/functions/functions";

const ModalCheckBuyDomain = (props) => {
    const [selectedTab, setSelectedTab] = useState(0)
    const [awsApps, setAwsApps] = useState([])
    const event = useParams()
    const context = useContext(MainContext)
    const [isRegisterDisable, setIsRegisterDisable] = useState(true)
    const [childKey, setChildKey] = useState(1);

    const {
        userIsSuperAdmin,
        userIsDev
    } = useUser()

    useEffect(() => {
        async function fetchData() {
            try {
                const response = await getAwsApps()
                setAwsApps(response)
            }
            catch (e) { }
        }
        fetchData()
    }, [])

    const close = () => {
        // Assign a new key in order to destroy the old component.
        // This helps to start a fresh request with no error/success messages
        setChildKey(Math.floor(Math.random() * 100))
        setIsRegisterDisable(true)
        setSelectedTab(0)
        context.setModalCheckBuyDomainOpen(false)
        context.setModalCheckBuyDomainValue()
    }
    const changeTab = (tabIndex) => {
        setSelectedTab(tabIndex)
    }
    const updateDomainName = (domainName) => {
        context.setModalCheckBuyDomainValue(domainName)
    }
    const checkDomainAvailabilityForm = (
        <CheckDomainAvailabilityForm
            event={event}
            modal={true}
            onRequestClose={close}
            hasForm={true}
            onChangeTabClicked={changeTab}
            onUpdateDomainName={updateDomainName}
            defaultValues={{
                domain_name: context.modalCheckBuyDomainValue
            }}
            setIsRegisterDisable={setIsRegisterDisable}
            hideRegisterLinkRef={context.isStagingAndUserNotAdmin}
            hideAttachLinkRef={context.isStagingAndUserNotAdmin}
        />
    )
    const registerDomainForm = (
        <RegisterDomainForm
            event={event}
            modal={true}
            onRequestClose={close}
            hasForm={true}
            onUpdateDomainName={updateDomainName}
            userIsSuperAdmin={userIsSuperAdmin()}
            awsApps={awsApps}
            defaultValues={{
                domain_name: context.modalCheckBuyDomainValue
            }}
        />
    )
    const createDomainAssociationForm = (
        <CreateDomainAssociationForm
            event={event}
            modal={true}
            onRequestClose={close}
            hasForm={true}
            hideAppId={!userIsSuperAdmin()}
            hideBranch={true}
            onUpdateDomainName={updateDomainName}
            userIsSuperAdmin={userIsSuperAdmin()}
            awsApps={awsApps}
            defaultValues={{
                domain: context.modalCheckBuyDomainValue
            }}
        />
    )

    let title = "Handle domains"

    return (
        <ComposedModal
            // buttonTriggerText="Launch modal"
            // modalHeading="Modal heading"
            // className="media-gallery-modal"
            // passiveModal
            size='sm'
            open={context.modalCheckBuyDomainOpen}
            // modalLabel="Media gallery"
            preventCloseOnClickOutside
            onClose={close}
        >
            <ModalHeader
                title={title}
                buttonOnClick={close} />
            <Tabs tabContentClassName="p-0" selected={selectedTab} key={childKey}>
                <Tab label={"Verify"} onClick={() => setSelectedTab(0)}>
                    {checkDomainAvailabilityForm}
                </Tab>
                {!context?.isStagingAndUserNotAdmin && <Tab disabled={isRegisterDisable} label={<span style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>Register <span style={{ color: "red" }}></span></span>} onClick={() => setSelectedTab(1)}>
                    {registerDomainForm}
                </Tab>}
                {!context?.isStagingAndUserNotAdmin && <Tab label={<span style={{ display: "flex", justifyContent: "center", flexWrap: "wrap" }}>Attach <span style={{ color: "red" }}></span></span>} onClick={() => setSelectedTab(2)}>
                    {createDomainAssociationForm}
                </Tab>
                }
            </Tabs>

        </ComposedModal>
    )
}

export default ModalCheckBuyDomain